import { Component } from '@angular/core';
import { LoginModel, UserPermissionsModel } from '../../../Models/ApplicationModels';
import { Router } from '@angular/router';
import { MasterDataSeriveService } from '../../../Services/master-data-serive.service';
import * as $ from 'jquery';
import { NgxPermissionsService } from 'ngx-permissions';
import { UserserviceService } from 'src/app/Services/userservice.service';
import { environment } from 'src/app/environments/environment';
import { LifecycleEnrollmentService } from '../../admin-module/admin-services/lifecycle-enrollment.service';
import { getProductionReportRoute } from '../production-services/production-report-routes.config';

@Component({
  selector: 'app-production-home',
  templateUrl: './production-home.component.html',
  styleUrls: ['./production-home.component.css']
})
export class ProductionHomeComponent {
  userDetails: LoginModel = new LoginModel();
  isDropdownOpen: boolean = false;
  isMenuItemActive: boolean[] = [true, false, false, false, false, false, false, false];
  isV3ReportsEnrolled: boolean = false;
  constructor(
    private permissionService: NgxPermissionsService,
    private userservice: UserserviceService,
    private masterService: MasterDataSeriveService,
    private route: Router,
    private router: Router,
    private lifecycleEnrollmentService: LifecycleEnrollmentService
  ) { }

  ngOnInit() {
    this.userDetails = this.masterService.getUserDetailsFromStorage();
    this.getBreadcrums();
    this.getPermissionsByUserId();
    this.lifecycleEnrollmentService.isEnrolled$().subscribe((isEnrolled) => {
      this.isV3ReportsEnrolled = isEnrolled;
    });
  }

  get productionOverviewRoute(): string {
    return getProductionReportRoute('productionOverview', this.isV3ReportsEnrolled);
  }

  get topPerformerRoute(): string {
    return getProductionReportRoute('topPerformer', this.isV3ReportsEnrolled);
  }

  get showChatbot(): boolean {
    return environment.environmentName === 'dev' || environment.environmentName === 'tst';
  }

  ngAfterViewInit(): void {

    $(".menu > ul > li").click(function (e) {
      // If has sub menu open it
      $(this).find(".sub-menu").slideToggle();

      // Closing others sub menu if any open
      $(".menu > ul > li").not(this).not('.active').find(".sub-menu").slideUp();
    });

    $(".breadcrumbs-section .menu > ul > li").click(function (e) {
      $(".sidebar .sub-menu").slideUp();
    });

    $(document).on("click", function (e) {
      if (!$(e.target).closest(".menu > ul > li").length) {
        $(this).find(".sub-menu").slideUp();
      }
    });
  }

  getBreadcrums() {

    const routeURL = this.route.url;
    if (routeURL.includes('departments') || routeURL.includes('prod-item') || routeURL.includes('sub-dept')) {
      this.getDataForMenu(0)
    }

    else if (routeURL.includes('production-overview')) {
      this.getDataForMenu(1)
    }

    else if (routeURL.includes('performer')) {
      this.getDataForMenu(2)
    }

    else if (routeURL.includes('move-floor')) {
      this.getDataForMenu(3)
    }

    else if (routeURL.includes('counting') || routeURL.includes('movement') || routeURL.includes('transfer') || routeURL.includes('onhands') || routeURL.includes('history')) {
      this.getDataForMenu(4)
    }
    else if (routeURL.includes('new-entry')) {
      this.getDataForMenu(5)
    } else if (routeURL.includes('scan-pulls')) {
      this.getDataForMenu(6)
    }
    else if (routeURL.includes('chatbot')) {
      this.getDataForMenu(7)
    }
  }

  getDataForMenu(indx: number) {

    this.isMenuItemActive.forEach((ele, i) => {
      if (indx == i) {
        this.isMenuItemActive[i] = true;
      }
      else {
        this.isMenuItemActive[i] = false;
      }
    });
  }

  getPermissionsByUserId() {
    this.userservice.getUserRolesandPerm().then((res) => {

      let permissions = res as UserPermissionsModel[];

      let perm: string[] = [];

      permissions?.forEach((pr) => {
        perm.push(pr.name);
      })


      this.permissionService.loadPermissions(perm);
    })
  }


}
